import moment from 'moment';

import Model from 'src/storage/base';
import { hasSameId } from 'src/helpers';

export class ClinicProfileDoctorModel extends Model {
  id = 'ClinicProfileDoctorModel';
  defaultState = () => ({
    doctor: null,
    slots: [],
    slotsMonth: [],
    selectedDate: moment(),
    hospitals: [],
    clinic: null
  });
  _events = {
    'foxsocket:message:contact_update': 'handleContactUpdateWS'
  };
  apiConfig = {
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    },
    list: {
      url: 'schedule/list',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    },
    hospitals: {
      url: 'hospital/list',
      validation: {
        skip: 'number',
        limit: 'number'
      },
      cancellable: true
    },
    account: {
      url: 'account/detail',
      validation: {
        id: 'userId'
      }
    }
  };

  loadDetail = (id, cb) => {
    this.setState({
      hospitals: [],
      clinic: null
    });
    this.api('doctor_detail', { id }, (error, doctor, success) => {
      if (!error) {
        const nextDoctor =
          this.state.doctor?.id === doctor?.id ? { ...this.state.doctor, ...doctor } : doctor;

        this.setState({
          doctor: nextDoctor,
          hospitals: [],
          clinic: null
        });
        this.loadHospitals({
          userId: id,
          clinicIds: nextDoctor?.clinicIds,
          hospitalIds: nextDoctor?.hospitalIds,
          skip: 0,
          limit: 100
        });
        this.selectedMonth(moment());
        if (nextDoctor.clinicIds?.length > 0) {
          this.api('account', { id: nextDoctor.clinicIds[0] }, (error, clinic) => {
            if (!error) {
              this.setState({ clinic });
            }
          });
        }
      }
      cb && cb(error, doctor, success);
    });
  };

  handleContactUpdateWS = ({ data }) => {
    const doctorId = data?.partnerId || data?.id;
    const currentDoctor = this.state.doctor;

    if (
      !currentDoctor ||
      !hasSameId(currentDoctor.id, doctorId) ||
      typeof data?.connections === 'undefined'
    ) {
      return;
    }

    this.setState({
      doctor: {
        ...currentDoctor,
        connections: data.connections,
        ...(typeof data?.lastActivity !== 'undefined' ? { lastActivity: data.lastActivity } : {})
      }
    });
  };

  loadHospitals = (req) => {
    this.api('hospitals', req, (error, data) => {
      if (!error) {
        this.setState({
          hospitals: data.items
        });
      }
    });
  };

  selectedDay = (day) => {
    this.setState({
      selectedDate: day,
      slots: this.state.slotsMonth.filter(
        (s) => s.startDate >= day.clone().startOf('day') && s.startDate <= day.clone().endOf('day')
      )
    });
  };

  selectedMonth = (day) => {
    const start = day.clone().startOf('month').startOf('week');
    const end = day.clone().endOf('month').endOf('week');
    this.setState({ slotsMonth: [] });
    this.api(
      'list',
      {
        id: this.state.doctor.id,
        from: Math.max(start.valueOf(), moment().valueOf()),
        to: end.valueOf()
      },
      (err, res, success) => {
        if (success)
          this.setState({
            slotsMonth: res.map((slot) => {
              slot.slotDate = moment(slot.startDate).format('YYYYMMDD');
              if (!slot.patientId) slot.patientId = 0;
              return slot;
            })
          });
        this.selectedDay(this.state.selectedDate);
      }
    );
  };
}

const model = new ClinicProfileDoctorModel();
export default model;
